import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { getGallery } from 'modules/gallery';

// Start loading the gallery before React renders.
getGallery().catch(() => {});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
